export default {
  SPONSOR: "e9ac25a0-7ecc-41b3-a6ff-a7cf0fcd9a1f",
  LENDER: "aac71c43-3ad4-4e8e-90ef-b578fd32b51e",
  OTHER: "e18bf8b5-8b6f-4d01-a91b-efa8e5af2197",
  HEDGE_PROVIDER: "a4b736a6-a150-42d6-b310-6d9afdeb9015",
  BROKER: "8d6df618-4a9f-4e16-b010-0acbb92c5e20",
  GUARANTOR: "8a156419-c946-44f8-80c1-cf67b0a618d6",
  DEFEASANCE_CONSULTANT: "80119ba2-3e52-4be0-b851-0fcce4cbfd9b",
  SERVICER: "7b636a43-2b09-47e3-af28-9ffcaec1bcc2",
  BORROWERS_COUNSEL: "78f6dc0d-9ffc-4624-b2e3-031ce25581af",
  SALES_BROKER: "664d1403-c113-4dcf-aada-fd9b7c539293",
  HEDGE_ADVISOR: "249fa0c2-e304-41d3-a72d-175b8597a94a",
  JV_PARTNER: "2152f206-9ca0-4b34-955c-96a60485252c",
  LENDERS_COUNSEL: "019542e8-cd53-4355-a703-9f545ef47f61"
};
